import KitCfg from "../KitCfg";
import KitLog from "../KitLog";
import {DeviceData} from "./DeviceData";
import internal from "node:stream";
import {SmIDQuery} from "./SmIDQuery";
import {IapConstants} from "./IapConst";
import {KitBehaviour} from "../KitBehaviour";
import {AvoidResult} from "./AvoidResult";
import {RiskFactory} from "./RiskFactory";
import {KitEvent} from "../Track/KitEvent";
import {KitConst} from "../KitConst";
import {JsonData} from "@/Fwk/Kit/JsonData";

export class KitIAP {
    static TAG = "[IAP]";
    private static WHAT_RETURN_TIMEOUT = "IAP_RETURN_TIMEOUT";
    static RESTRICT = 1; //是否限制 1限制 2不限制
    static NO_RESTRICT = 2;
    static _isSilent = false;

    // 场景是否已经回调
    private static mCallback = new Map<number, boolean>();

    // 场景的兜底配置
    private static mDefaultConfig = new Map<number, JsonData>();

    // 场景的请求返回加过
    private static mRequestConfig = new Map<number, JsonData>();

    // userGroup
    private static mUserGroup = new Map<number, JsonData>();

    // 场景对应userId
    private static mUserId = new Map<number, string>();

    static Init(isSilent: boolean) {
        this._isSilent = isSilent;
        const host = KitCfg.ia_host;
        if (!host) {
            if (KitLog.IsLog) this.Log("iap请求域名不能为空");
            return;
        }

        DeviceData.Init();
    }

    static GetOrQuerySmID(): string {
        const smID = DeviceData.GetSmID();
        //获取数盟ID，成功后才请求iap服务器
        if (!smID) {
            SmIDQuery.Query();
        }

        return smID;
    }

    public static SetSilent(isSilent: boolean) {
        this._isSilent = isSilent;
    }

    static requestIsRestrict(
        scene: number,
        defaultConfig: JsonData,
        userGroup: JsonData,
        timeout: number = 20
    ) {
        try {
            this.mUserGroup.set(scene, userGroup);
            this.mUserId.set(scene, userGroup.OptString(IapConstants.USER_ID) ?? "");
        } catch (Exception) {
            if (KitLog.IsLog) this.Log(`解析userId为空`);
        }

        if (KitLog.IsLog) this.Log(`开始风控判断，scene={scene},超时时间:${timeout},账户信息:${userGroup}`);
        KitBehaviour._timer.SetTimer(this.WHAT_RETURN_TIMEOUT + scene, () => {
            this.TimeOver(scene);
        }, 1, 0);

        this.mCallback.set(scene, false);
        this.mDefaultConfig.set(scene, defaultConfig);

        const smID = DeviceData.GetSmID();

        //获取数盟ID，成功后才请求iap服务器
        if (!smID) {
            SmIDQuery.QueryScene(scene, this.DoRequest);
        } else {
            this.DoRequest(scene, smID);
        }
    }

    private static DoRequest(scene: number, smId: string) {
        if (!smId) {
            if (KitLog.IsLog) this.Log(`scene=${scene}, 获取数盟ID超时，兜底返回结果`);
            this.ResponseDef(scene);
            return;
        }

        if (this._isSilent) {
            if (KitLog.IsLog) this.Log(`scene=${scene},静默模式，兜底返回结果`);
            this.ResponseDef(scene);
            return;
        }

        if (KitLog.IsLog) this.Log(`scene=${scene}, 数盟ID:${smId},发起服务器请求`);
        const ug = this.mUserGroup.get(scene)!;
        this.mRequestConfig.set(scene, DeviceData.buildBaseParams(scene, ug));

        this.TrackRequest(scene);

        // IapRequest.Request(scene, this.mRequestConfig.get(scene)!, this.onAvoidResult);
    }


    private static onAvoidResult(result: AvoidResult) {
        KitBehaviour._timer.clearTask(this.WHAT_RETURN_TIMEOUT + result.scene);

        if (this.mCallback.get(result.scene)) {
            if (KitLog.IsLog) this.Log(`使用了兜底策略返回，忽略`);
            return;
        }

        if (result.success) {
            if (KitLog.IsLog) this.LogLongText(`scene=${result.scene}, 请求返回结果:`, `${result.data?.toString()}`);
            this.Response(result.scene, result.restrict, result.data ?? new JsonData());
        } else {
            if (KitLog.IsLog) this.Log(`scene=${result.scene}, 请求错误兜底返回结果`);
            this.ResponseDef(result.scene);
        }
    }

    private static TimeOver(scene: number) {
        this.mCallback.set(scene, true);
        if (KitLog.IsLog) this.Log(`scene=${scene}, 超时：返回兜底结果`);
        this.ResponseDef(scene);
    }

    private static Response(scene: number, restrict: number, reason: JsonData) {
        const userId = (this.mUserId.has(scene) ? this.mUserId.get(scene) : "") ?? "";
        const riskBean = RiskFactory.mrResponse(scene, restrict, reason);
        const result = riskBean.result?.toString() ?? "";
        //统计
        this.TrackMrRsp(scene, userId, riskBean.isDef.toString(), riskBean.defRule, DeviceData.GetSmID(),
            riskBean.restrict.toString());
        //回调业务层
        if (KitLog.IsLog) this.Log(`scene=${scene}, 返回结果:${result}`);
        // KitGame.OnIAP(0, result);
    }


    private static ResponseDef(scene: number) {
        const userId = this.mUserId.get(scene) ?? "";
        const defJson = this.mDefaultConfig.get(scene) ?? new JsonData();
        const reqJson = this.mRequestConfig.get(scene) ?? DeviceData.buildBaseParams(scene, this.mUserGroup.get(scene) ?? new JsonData());
        const riskBean = RiskFactory.mrResponseDef(scene, defJson, reqJson);
        const result = riskBean.result.toString();
        //统计
        this.TrackMrRsp(scene, userId, riskBean.isDef.toString(), riskBean.defRule, DeviceData.GetSmID(),
            riskBean.restrict.toString());
        //回调业务层
        // KitGame.OnIAP(0, result);
    }

    static TrackRequest(scene: number) {
        KitEvent.track512(IapConstants.C_MR_HTTP_REQ)
            .Put1(scene)
            .Put(IapConstants.SDK_VERSON_CODE, KitConst.KIT_VERSION_CODE)
            .Put(IapConstants.SDK_VERSON_NAME, KitConst.KIT_VERSION_NAME)
            .Put(IapConstants.REQ_INDEX, 0)
            .Commit();
    }

    static TrackSucc(scene: number, consumeTime: number, httpCode: number) {
        KitEvent.track512(IapConstants.C_MR_HTTP_SUCC)
            .Put1(scene)
            .Put(IapConstants.SDK_VERSON_CODE, KitConst.KIT_VERSION_CODE)
            .Put(IapConstants.SDK_VERSON_NAME, KitConst.KIT_VERSION_NAME)
            .Put(IapConstants.REQ_INDEX, 0)
            .Put(IapConstants.CONSUME_TIME, consumeTime)
            .Put(IapConstants.HTTP_CODE, httpCode)
            .Commit();
    }

    static TrackFail(scene: number, consumeTime: number, httpCode: number, errorCode: number, msg: string) {
        KitEvent.track512(IapConstants.C_MR_HTTP_FAIL)
            .Put1(scene)
            .Put(IapConstants.SDK_VERSON_CODE, KitConst.KIT_VERSION_CODE)
            .Put(IapConstants.SDK_VERSON_NAME, KitConst.KIT_VERSION_NAME)
            .Put(IapConstants.REQ_INDEX, 0)
            .Put(IapConstants.CONSUME_TIME, consumeTime)
            .Put(IapConstants.HTTP_CODE, httpCode)
            .Put(IapConstants.ERROR_CODE, errorCode)
            .Put(IapConstants.ERROR_MSG, msg)
            .Commit();

    }

    static TrackError(scene: number, consumeTime: number, errorCode: number, msg: string) {
        KitEvent.track512(IapConstants.C_MR_NET_ERROR)
            .Put1(scene)
            .Put(IapConstants.SDK_VERSON_CODE, KitConst.KIT_VERSION_CODE)
            .Put(IapConstants.SDK_VERSON_NAME, KitConst.KIT_VERSION_NAME)
            .Put(IapConstants.REQ_INDEX, 0)
            .Put(IapConstants.CONSUME_TIME, consumeTime)
            .Put(IapConstants.ERROR_CODE, errorCode)
            .Put(IapConstants.ERROR_MSG, msg)
            .Commit();
    }

    static TrackMrRequest(scene: number, userId: string, requestExt: string, sm_id: string) {
        KitEvent.track513(IapConstants.C_MR_REQ)
            .Put1(scene)
            .Put(IapConstants.REQ_INDEX, 0)
            .Put(IapConstants.USERID, userId)
            .Put(IapConstants.REQUEST_EXT, requestExt)
            .Put(IapConstants.SM_ID, sm_id)
            .Commit();

    }


    static TrackMrRsp(scene: number, userId: string, is_def: string, def_rule: string, sm_id: string,
                      risk_result: string) {
        KitEvent.track513(IapConstants.C_MR_RSP)
            .Put1(scene)
            .Put(IapConstants.USERID, userId)
            .Put(IapConstants.IS_DEF, is_def)
            .Put(IapConstants.DEF_RULE, def_rule)
            .Put(IapConstants.SM_ID, sm_id)
            .Put(IapConstants.RISK_RESULT, risk_result)
            .Commit();

    }

    static Log(msg: string) {
        KitLog.Log(this.TAG, msg);
    }

    static LogWarning(msg: string) {
        KitLog.LogWarning(this.TAG, msg);
    }

    static LogLongText(text: string, longText: string) {
        if (longText.length <= 800) {
            this.Log(text + longText);
            return;
        }

        this.Log(text);
        const maxLength = 500; // 假设控制台可以打印的最大长度是1000个字符
        let index = 0; // 字符串起始索引
        let remainingLength = longText.length; // 剩余待打印的字符串长度
        let i = 1;
        while (remainingLength > 0) {
            // 计算本次打印的字符串长度，避免超过控制台的限制
            const printLength = Math.min(maxLength, remainingLength);
            const segment = longText.substring(index, printLength);
            // 打印当前分段的字符串
            this.Log(`长文本Part${i}：${segment}`);
            // 更新索引和剩余长度
            i++;
            index += printLength;
            remainingLength -= printLength;
        }
    }
}
